import { Options } from 'ky';
import config from 'config';
import qs from 'qs';
import { useAuthenticatedApiClient } from 'utils/apiClient/base';
import { requestUpload } from 'utils/api';
import { RcFile } from 'antd/es/upload/interface';
import { StocktakingExportTemplate } from 'utils/apiClient/services/inventory/types';

const stocktakingClientOpts: Options = {
  prefixUrl: `${config.CORE_URL}/api/`,
};

const apiVersion13 = {
  'x-api-version': '13',
};

const customJsonHeader = {
  'Content-Type': 'application/json',
};

/* eslint-disable import/prefer-default-export */
export const useStocktakingApi = () => {
  const authenticatedApiClient = useAuthenticatedApiClient();
  const stocktakingApiClient = authenticatedApiClient.extend(
    stocktakingClientOpts
  );

  return {
    fetchJobs: (report_type: string) => {
      const params =
        report_type === 'stock_import'
          ? { type: ['stock_import'] }
          : { type: ['stock_export'] };
      const uParams = { limit: 50, ...params };
      const paramsQs = qs.stringify(uParams, {
        addQueryPrefix: true,
        skipNulls: true,
        arrayFormat: 'comma',
      });

      const fullUrl = ['jobs/', paramsQs].join('');
      return stocktakingApiClient.get(fullUrl).json<any>();
    },
    generateStockTakingTemplate: async (lang: string) => {
      const data = await stocktakingApiClient
        .post(`products/stocktaking/export/?language=${lang.toLowerCase()}`, {
          headers: {
            ...apiVersion13,
            ...customJsonHeader,
          },
        })
        .json<StocktakingExportTemplate>();
      const { job_id } = data;
      if (!job_id) {
        throw Error('No job_id was returned for template generation.');
      }
    },
    uploadStockTakingTemplate: async (
      userToken: string,
      import_file: RcFile | null
    ) => {
      const url = `${config.CORE_URL}/api/products/stocktaking/import/`;
      await requestUpload({
        url,
        userToken,
        requestData: { import_file },
      });
    },
  };
};
